module.exports = __webpack_public_path__ + "img/70.4314e11b.svg";